import { FAContent } from './types/content';
import { useFeatureServices } from './use-feature-services';

export const useFeatureAppContent = () => {
  const faContentService = useFeatureServices()["fa-content-service"];

  if (!faContentService) {
    throw new Error('No feature app content was provided.');
  }

  return faContentService.content as FAContent;
};
